/*** IMPORTS FROM imports-loader ***/
var define = false;

// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

